import * as React from 'react';

function IconActionSearchMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M16.84 14.84C17.5973 13.7026 18.0009 12.3665 18 11C18.0021 9.44208 17.4844 7.92799 16.5289 6.69749C15.5733 5.46698 14.2347 4.5904 12.7248 4.20654C11.2149 3.82267 9.62007 3.95348 8.1929 4.57823C6.76573 5.20298 5.58776 6.28598 4.84552 7.65573C4.10328 9.02548 3.83919 10.6037 4.09508 12.1405C4.35096 13.6772 5.11219 15.0847 6.25823 16.14C7.40426 17.1954 8.8696 17.8382 10.4222 17.9668C11.9748 18.0954 13.526 17.7024 14.83 16.85L18 20L20 18L16.84 14.84ZM6 11C6 10.0111 6.29325 9.0444 6.84266 8.22215C7.39206 7.39991 8.17296 6.75905 9.08659 6.38061C10.0002 6.00217 11.0056 5.90315 11.9755 6.09608C12.9454 6.28901 13.8363 6.76521 14.5355 7.46447C15.2348 8.16373 15.711 9.05465 15.9039 10.0246C16.0969 10.9945 15.9978 11.9998 15.6194 12.9134C15.241 13.8271 14.6001 14.6079 13.7779 15.1574C12.9556 15.7068 11.9889 16 11 16C9.67392 16 8.40215 15.4732 7.46447 14.5355C6.52679 13.5979 6 12.3261 6 11Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconActionSearchMedium;
